import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "loadMore"]

  async loadMore(event) {
    const btn = event.currentTarget
    const url = btn.dataset.url
    if (!url) return

    btn.textContent = "…"
    btn.style.pointerEvents = "none"

    const response = await fetch(url, { headers: { "Accept": "text/html" } })
    const html = await response.text()
    const doc = new DOMParser().parseFromString(html, "text/html")

    const newCards = doc.querySelectorAll(".blog-scroll-card")
    const loadMoreEl = this.loadMoreTarget
    newCards.forEach(card => this.trackTarget.insertBefore(card, loadMoreEl))

    const nextBtn = doc.querySelector("[data-blog-scroll-target='loadMore']")
    if (nextBtn && nextBtn.dataset.url) {
      btn.dataset.url = nextBtn.dataset.url
      btn.textContent = "Mehr →"
      btn.style.pointerEvents = ""
    } else {
      loadMoreEl.remove()
    }
  }
}
